import type { UploadFile } from 'antd';
import { useServices } from 'containers/services';
import { useMutation, type UseMutationResult } from 'react-query';
import { notifyError, notifySuccess } from 'utils/notifications';
import { MUTATION_KEYS } from 'utils/queryKeys';

export const useUploadHardwareList = (onSuccess: () => void): UseMutationResult<void, unknown> => {
  const { hardwaresApiClient } = useServices();

  return useMutation((file: UploadFile) => hardwaresApiClient.uploadCsv(file), {
    mutationKey: MUTATION_KEYS.hardwares.uploadHardwareList(),
    onSuccess: () => {
      notifySuccess({
        message: `List uploaded`,
      });
      onSuccess();
    },
    onError: error => {
      notifyError(error, {
        message: 'There was an error while uploading list.',
      });
    },
  });
};
